import { Component, Input, OnInit, Renderer2, ViewChild } from "@angular/core";
import { ConfirmationService, FilterMetadata } from "primeng/api";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  EMPTY,
  Observable,
  Subject,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from "rxjs";
import { Router } from "@angular/router";
import * as FileSaver from "file-saver";
import saveAs from "file-saver";
import * as XLSX from "xlsx";
import { CommonModule, DatePipe } from "@angular/common";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { GenericFilterRequestDto } from "../../../core/models/generic-filter-request.dto";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { GenericSortRequestDto } from "../../../core/models/generic-sort-request.dto";
import { GetAllBuyersRequestDto } from "../../../core/models/orders/getAllBuyersRequestDto";
import { GetAllBuyersResponseDto } from "../../../core/models/orders/getAllBuyersResponseDto";
import { AddWorkflowHeaderListDto } from "../../../core/models/project-workflow/addWorkflowHeaderListDto";
import { CustomFilterDto } from "../../../core/models/project-workflow/customFilterDto";
import { ProductionWorkflowAdditionalFilters } from "../../../core/models/project-workflow/productionWorkflowAdditionalFilters";
import { ProductionWorkflowLineDto } from "../../../core/models/project-workflow/productionWorkflowLineDto";
import { ProductionWorkflowListDto } from "../../../core/models/project-workflow/productionWorkflowListDto";
import { UpdateProjectWorkflowFlagDto } from "../../../core/models/project-workflow/updateProjectWorkflowFlagDto";
import { UpdateProjectWorkflowIhdDto } from "../../../core/models/project-workflow/updateProjectWorkflowIhdDto";
import { UpdateProjectWorkflowSortingDto } from "../../../core/models/project-workflow/updateProjectWorkflowSortingDto";
import { WorkflowNotificationSettings } from "../../../core/models/project-workflow/workflownotificationSettingDto";
import { WorkflowStatusDto } from "../../../core/models/project-workflow/workflowStatusDto";
import { ClientSearchList } from "../../../core/models/shared/clientSearchList";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { BuyerService } from "../../../core/services/buyer.service";
import { CustomerAccountService } from "../../../core/services/customer-account.service";
import { LoaderService } from "../../../core/services/loader.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { exportExcel } from "../../../core/services/shared.service";
import { EnumPhaseStatus } from "../../../shared/enums/enumPhaseStatus";
import { EnumWorkflowHeaderColorStatus } from "../../../shared/enums/enumWorkflowHeaderColorStatus";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import { WorkflowStatusEnum } from "../../../shared/enums/workflowStatusEnum";
import { AddWorkflowUpdatesComponent } from "../add-workflow-updates/add-workflow-updates.component";
import { UserManagementService } from "../../../core/services/user-management.service";
import {
  TableLazyLoadEvent,
  TableModule,
  TableRowReorderEvent,
} from "primeng/table";
import { DatePickerModule } from "primeng/datepicker";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { ProductionWorkflowSummaryComponent } from "../production-workflow-summary/production-workflow-summary.component";
import { DialogModule } from "primeng/dialog";
import { Popover, PopoverModule } from "primeng/popover";
import {
  FileUpload,
  FileUploadHandlerEvent,
  FileUploadModule,
} from "primeng/fileupload";
import { WorkflowLineItemsComponent } from "../workflow-line-items/workflow-line-items.component";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { NotificationSettingsComponent } from "../notification-settings/notification-settings.component";
import { CreateSampleWorkflowHeaderRequestDto } from "../../../core/models/project-workflow/createSampleWorkflowHeaderRequestDto";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { RadioButtonModule } from "primeng/radiobutton";
import { replaceString } from "../../../shared/globalfunction";
import { MarkAsArchiveRequestDto } from "../../../core/models/project-workflow/markAsArchiveRequestDto";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";
@UntilDestroy()
@Component({
  selector: "jni-production-workflow-archived-listing",
  templateUrl: "./production-workflow-archived-listing.component.html",
  styleUrls: ["./production-workflow-archived-listing.component.scss"],
  providers: [ConfirmationService],
  imports: [
    TableModule,
    CommonModule,
    DatePickerModule,
    ModalStackerComponent,
    ProductionWorkflowSummaryComponent,
    DialogModule,
    PopoverModule,
    FileUploadModule,
    WorkflowLineItemsComponent,
    ConfirmDialogModule,
    SelectModule,
    FormsModule,
    AddWorkflowUpdatesComponent,
    NotificationSettingsComponent,
    SpinnerComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    RadioButtonModule,
    FormsModule,
    ConfirmDialogComponent,
  ],
})
export class ProductionWorkflowArchivedListingComponent implements OnInit {
  selectedOption!: string;

  constructor(
    private _workflowService: ProjectWorkflowService,
    private _toastr: JniToastrService,
    private route: Router,
    private renderer: Renderer2,
    private _loaderService: LoaderService,
    private datePipe: DatePipe,
    private _customerAccountService: CustomerAccountService,
    private _loginService: UserManagementService,
    private _buyerService: BuyerService,
    private confirmationService: ConfirmationService
  ) {
    this.getObjectFromSalesOrderLines = this.route.getCurrentNavigation()
      ?.extras.state as {
      workflowId: number;
      salesOrderId: string;
    };

    if (this.getObjectFromSalesOrderLines) {
      this.workflowId = this.getObjectFromSalesOrderLines.workflowId;
      this.salesOrderId = this.getObjectFromSalesOrderLines.salesOrderId;

      this.showWorkflowSummaryDialog = true;
    }
  }

  ngOnInit(): void {
    this.getWorkflowStatusList();

    if (this.customerId) {
      this.showListView(false);
    }
    this.searchCustomerName();
    this.getUserProfile();
    this.searchBuyerName();
  }

  @Input() customerId = "";
  @Input() isRedirectedFromClient = false;
  @Input() clientAlias = "";
  allTrue = true;
  searchPlaceholder = "Search";
  listView = true;
  lazyLoadEvent!: TableLazyLoadEvent;
  showSmallLoader = false;
  currentPagination = 50;
  totalRecords = 0;
  defaultTake = 50;
  workflowList: ProductionWorkflowListDto[] = [];
  listAfterGridFilter: ProductionWorkflowListDto[] = [];
  selectedRadioButton = "0";
  filterTextChanged: Subject<Event | string | null> = new Subject<
    Event | string | null
  >();
  filterDebounceTime = 1000;
  showWorkflowDialog = false;
  showWorkflowSummaryDialog = false;
  showSalesOrderSummaryDialog = false;
  workflowId!: number;
  salesOrderId!: string;
  //enteredSalesOrderId = '';
  salesOrderlist: [] = [];
  notificationSettings = [] as WorkflowNotificationSettings[];
  viewSettingsModal = false;
  getObjectFromSalesOrderLines!: {
    workflowId: number;
    salesOrderId: string;
  };
  showUploadWorkflow = false;
  @ViewChild("workflowFileUpload") fileUpload!: FileUpload;
  workflowStatusList = [] as WorkflowStatusDto[];
  isDelivered = false;
  displaySidebarForNotes = false;
  @ViewChild("workflowupdatesidebar", { static: false })
  workflowupdatesidebar!: AddWorkflowUpdatesComponent;
  descriptionCharacterCond = false;
  inHandDateCurrentdate = new Date();
  showCustomFilterDialog = false;
  selectedColumnName = "";
  customValue = "";
  customFilterDto!: CustomFilterDto;
  isCustomFilter = false;
  isTextInput = true;
  isDateInput = false;
  isPhaseList = false;
  isStatusList = false;
  isRadioInput = false;
  customDate = "";
  linesPreview = false;
  orderLines = [] as ProductionWorkflowLineDto[];
  buyerLists: GetAllBuyersResponseDto[] = [];
  public buyerVendor$ = new Subject<string>();
  isDragOver = false;
  deliveryAddress = [
    {
      id: 1,
      name: "One Time",
      status: false,
    },
    {
      id: 2,
      name: "Bill To",
      status: false,
    },
    {
      id: 3,
      name: "Client Address Book",
      status: false,
    },
    {
      id: 4,
      name: "Multi Ship To",
      status: false,
    },
    {
      id: 5,
      name: "TBD",
      status: false,
    },
  ];

  columnsList = [
    { name: "isflag", label: "Flag", table: "workflowheader" },
    { name: "id", label: "Project", table: "workflowheader" },
    { name: "namealiasd365", label: "Client", table: "client" },
    { name: "jobnamed365", label: "Job Name", table: "salesorderheader" },
    { name: "buyeremail", label: "POC", table: "salesorderheader" },
    { name: "inhanddated365", label: "IHD", table: "salesorderheader" },
    { name: "salesorderidd365", label: "Order", table: "salesorderheader" },
    { name: "firstname", label: "BC", table: "brandingconsultant" },
    { name: "coowner", label: "Owner", table: "coowner" },
    { name: "status", label: "Project Status", table: "projectworkflowstatus" },
    { name: "lastupdate", label: "Last", table: "workflowheader" },
    { name: "phasestatusid", label: "Phase", table: "workflowheader" },
  ];

  phaseList = [
    { id: 1, status: "Pre Sale" },
    { id: 2, status: "Production" },
    { id: 3, status: "Delivered" },
    { id: 4, status: "Cancelled" },
    { id: 5, status: "Completed" },
  ];

  customerIdD365 = "";
  jobName = "";
  buyerName = "";
  public customerSearch$ = new Subject<string>();
  customerLists = [] as ClientSearchList[];
  isAdmin = false;
  projectHasUnSavedValues = false;
  archiveMessage = "You want to mark the project <b>{0}</b> as {1}.";
  archiveAlertVisible = false;
  archivedProject = 0;
  archivedProjectStatus = false;

  showListView(isListView: boolean) {
    this.listView = isListView;
    if (this.isRedirectedFromClient == true) {
      this.selectedRadioButton = "11"; // As by default Archive All radio is selected;
      this.selectedOption = "11";
      this.onFilterInput("Archive");
    } else {
      this.selectedRadioButton = "0";
      this.selectedOption = "0";
      this.onFilterInput("All");
    }
  }

  getAllWorkflows(event: TableLazyLoadEvent) {
    this.lazyLoadEvent = event;
    this.showSmallLoader = true;
    const eventFilterArray = Object.keys(event.filters ?? {});
    const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      const tableFilter = event?.filters?.[x] as FilterMetadata;
      const data = {
        columnName: x ?? "",
        matchMode: tableFilter.matchMode ?? "",
        tableName: "",
        value: tableFilter.value ?? "",
      } as GenericFilterRequestDto;

      return data;
    });

    const sortArray: GenericSortRequestDto[] =
      event.multiSortMeta?.map(x => {
        return {
          ...x,
        } as GenericSortRequestDto;
      }) ?? [];
    filter.forEach(x => {
      if (x.columnName == "workflowId") {
        x.columnName = "Id";
        x.tableName = "workflowHeader";
      }
      if (x.columnName == "customerName") {
        x.columnName = "CustomerName";
        x.tableName = "workflowHeader";
      }
      if (x.columnName == "jobName") {
        x.columnName = "JobName";
        x.tableName = "workflowHeader";
      }
      if (x.columnName == "salesOrderIdD365") {
        x.columnName = "SalesOrderIdD365";
        x.tableName = "salesOrderHeader";
      }
      if (x.columnName == "brandingConsultant") {
        x.columnName = "FirstName,LastName";
        x.tableName = "brandingconsultant";
      }
      if (x.columnName == "namealiasd365") {
        x.columnName = "namealiasd365";
        x.tableName = "client";
        x.value = this.clientAlias;
      }

      if (x.columnName == "coowner") {
        x.columnName = "coowner";
        x.tableName = "coowner";
      }
    });

    const request: ProductionWorkflowAdditionalFilters = {
      skip: event.first ?? 0,
      take: event.rows ?? this.defaultTake,
      filters: filter,
      sort: sortArray,
      workflowListStatus: this.isRedirectedFromClient
        ? String(WorkflowStatusEnum.Archived)
        : this.selectedRadioButton,
      workflowStatusId: this.isRedirectedFromClient
        ? WorkflowStatusEnum.Archived
        : (parseInt(this.selectedRadioButton) ?? 0),
      customerAccountNumber: this.customerId,
      isCustomFilter: this.isCustomFilter,
      customFilter: this.customFilterDto,
      archiveWorkflowStatusId: this.isRedirectedFromClient
        ? parseInt(this.selectedRadioButton)
        : 0,
      archivedProject: true,
    };

    this._workflowService
      .getAllWorkflows(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.totalRecords = res.totalRecords ?? 0;
          this.workflowList = res.data;

          if (this.workflowList) {
            this.workflowList.forEach(workflow => {
              workflow.inHandDate = this.datePipe.transform(
                workflow.inHandDate,
                "MM-dd-yyyy"
              );
            });
          }

          this.showCustomFilterDialog = false;
        },
        error: res => {
          this.showSmallLoader = false;
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  getWorkflowOnChange(value: SelectChangeEvent) {
    this.selectedRadioButton = value.value;
    this.selectedOption = this.selectedRadioButton; // Update the selected option
    this.clearCustomFilter();
    this.onFilterInput(null);
  }

  onFilterInput($event: Event | string | null) {
    // if (this.filterTextChanged.observers.length === 0) {
    this.filterTextChanged
      .pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged())
      .subscribe(() => {
        this.getAllWorkflows(this.lazyLoadEvent);
      });
    // }
    this.filterTextChanged.next($event);
  }

  exportExcel() {
    exportExcel(this.workflowList, "Production Workflow");
  }

  exportExcelForFilterData() {
    const object = this.workflowList.map(datum => {
      return {
        ["Proposed Project"]: this.getPaddedWorkflowId(datum.workflowId),
        ["Client"]: datum.customerName,
        ["Buyer"]: datum.buyerName,
        ["Buyer Email"]: datum.buyerEmail,
        ["In-Hands Date"]: datum.inHandDate,
        ["Sales Order Id"]: datum.salesOrderIdD365,
        ["BC"]: datum.brandingConsultant,
        ["Workflow Status"]: datum.workflowStatus,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "Production Workflow");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  getPaddedWorkflowId(workflowId: number) {
    return workflowId.toString().padStart(6, "0");
  }

  openWorkflowModal() {
    this.customerIdD365 = "";
    this.jobName = "";
    this.buyerName = "";
    this.showWorkflowDialog = true;
  }

  closeWorkflowModal() {
    this.showWorkflowDialog = false;
  }

  openWorkflowSummaryModal(salesOrderId: string, workflowId: number) {
    this.salesOrderId = salesOrderId;
    this.workflowId = workflowId;
    this.showWorkflowSummaryDialog = true;
  }

  closeWorkflowSummaryModal() {
    if (this.projectHasUnSavedValues) {
      this.confirmProjectSummaryClose();
    } else {
      this.showWorkflowSummaryDialog = false;
      this.allTrue = true;
      this.showListView(true);
    }
  }

  openSalesOrderModal(salesOrderId: string) {
    const url = `/orders/order-summary/${salesOrderId}`;
    this.route.navigate([url]);
  }

  closeSalesOrderModal() {
    this.showSalesOrderSummaryDialog = false;
  }

  addNewProjectHeader() {
    this._loaderService.setLoaderState(true);
    if (!this.customerIdD365 || this.customerIdD365 === "") {
      this._toastr.error("Error", "Select a Client for Project");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (!this.jobName || this.jobName === "") {
      this._toastr.error("Error", "Enter Job Name for Project");
      this._loaderService.setLoaderState(false);
      return;
    }

    const request = {
      customerAccountNoD365: this.customerIdD365,
      jobName: this.jobName,
      buyerName: this.buyerName,
    } as CreateSampleWorkflowHeaderRequestDto;
    this._workflowService.addSampleWorkflowHeaderData(request).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res?.data) {
          this.showWorkflowDialog = false;
          this.openWorkflowSummaryModal("", res?.data?.WorkflowId ?? 0);
        } else {
          this._toastr.error("Error", res.message);
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", res.message);
      },
    });
  }

  closeModalExistingOrderNumber() {
    this.salesOrderId = "";
    this.showWorkflowDialog = false;
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  getNotificationSettings() {
    this._loaderService.setLoaderState(true);
    this._workflowService
      .getWorkflowNotificationSettings(0, true, 0, false)
      .subscribe({
        next: res => {
          if (res?.data) {
            this.notificationSettings = res?.data;
            this.showOrHideNotificationSettings();
          } else {
            this._toastr.error(
              "Error",
              "Unable to fetch notification settings"
            );
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._toastr.error("Error", "Unable to fetch notification settings");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  showOrHideNotificationSettings() {
    this.viewSettingsModal = !this.viewSettingsModal;
  }

  getWorkFlowHeaderCreateExcelTemplate() {
    this._workflowService.getWorkFlowHeaderCreateExcelTemplate().subscribe({
      next: res => {
        //this._loaderService.setLoaderState(false);
        this.downloadFile(res);
      },
      error: res => {
        this._toastr.error("Error", res.message);
        //this._loaderService.setLoaderState(false);
      },
    });
  }

  downloadFile(data: Blob) {
    const file = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(file, `ProductionWorkflowCreate_Template.xlsx`);
  }

  showOrHideUploadWorkflow() {
    this.fileUpload.clear();
    this.showUploadWorkflow = !this.showUploadWorkflow;
  }

  clearUploadFile() {
    this.fileUpload.clear();
  }

  addWorkflowHeaderList(
    event: {
      SalesOrderNumber: string;
      LineNumber: number;
      TrackingNumber: string;
      VendorSKU: string;
      IsMasterTracking: boolean;
    }[]
  ) {
    this.showUploadWorkflow = false;
    if (event.length <= 0) {
      this._toastr.error(
        "Error",
        "Selected Excel does not have rows for create Proposed Project"
      );
      this._loaderService.setLoaderState(false);
      this.fileUpload.clear();
      return;
    }

    const payload: AddWorkflowHeaderListDto[] = event.map(obj => {
      const data: AddWorkflowHeaderListDto = {
        saleOrderNumber: obj.SalesOrderNumber,
        lineNumber: obj.LineNumber,
        trackingNumber: obj.TrackingNumber,
        vendorSKU: obj.VendorSKU,
        isMasterTracking: obj.IsMasterTracking,
      };
      return data;
    });

    this._workflowService.postWorkflowHeaderList(payload).subscribe({
      next: res => {
        if (res?.data) {
          this._loaderService.setLoaderState(false);
          if (res && res.status === "Success") {
            this._toastr.success("Success", res.message);
            this.showListView(true);
          } else {
            this._toastr.error("Error", res.message);
          }
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._toastr.error("Error", "Unable to upload Excel File");
        this._loaderService.setLoaderState(false);
      },
    });
  }

  onUpload(event: FileUploadHandlerEvent) {
    this._loaderService.setLoaderState(true);
    const file = event.files[0];
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (e: ProgressEvent<FileReader>) => {
      /* create workbook */
      const binarystr: string = e.target?.result as string;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const rows = XLSX.utils.sheet_to_json<string[]>(ws, { header: 1 });
      const headers = rows[0];

      const requiredHeaders = [
        "SaleOrderNumber",
        "ClientAccountNumber",
        "Buyer",
        "WorkflowOwner",
        "CoOwner",
      ];
      const missingHeaders = requiredHeaders.filter(
        header => !headers.includes(header)
      );

      if (missingHeaders.length > 0) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          `Missing requied columns: ${missingHeaders.join(", ")}`
        );
        return;
      }

      /* save data */
      const data = XLSX.utils.sheet_to_json(ws).map((value: unknown) => {
        const obj = value as {
          SaleOrderNumber: string | number;
          LineNumber: string | number;
          TrackingNumber: string | number;
          VendorSKU: string | number;
          IsMasterTracking: string | boolean;
        };
        return {
          SalesOrderNumber: String(obj.SaleOrderNumber),
          LineNumber: Number(obj.LineNumber),
          TrackingNumber: String(obj.TrackingNumber),
          VendorSKU: String(obj.VendorSKU),
          IsMasterTracking: Boolean(obj.IsMasterTracking),
        };
      }); // to get 2d array pass 2nd parameter as object {header: 1}

      this.addWorkflowHeaderList(data);
    };
  }

  onDragEnter(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];

      // Validate file type
      if (
        !file.name.toLowerCase().endsWith(".xlsx") &&
        !file.name.toLowerCase().endsWith(".xls")
      ) {
        this._toastr.error(
          "File Upload Error",
          "Please select an Excel file (.xlsx or .xls)"
        );
        return;
      }

      // Validate file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        this._toastr.error(
          "File Upload Error",
          "File size must be less than 10MB"
        );
        return;
      }

      // Add the file to the PrimeNG FileUpload component
      if (this.fileUpload) {
        this.fileUpload.files = [file];
        // Trigger the upload
        const fakeEvent: FileUploadHandlerEvent = {
          files: [file],
        };
        this.onUpload(fakeEvent);
      }
    }
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }

  removeFile(file: File): void {
    const fileUpload = this.fileUpload;
    if (fileUpload) {
      const index = fileUpload.files?.indexOf(file);
      if (index !== undefined && index > -1) {
        fileUpload.files.splice(index, 1);
      }
    }
  }

  hideNotificationSettingDailog(event: boolean) {
    this.viewSettingsModal = event;
  }

  getWorkflowStatusList() {
    this._loaderService.setLoaderState(true);
    this._workflowService.getWorkflowStatusList().subscribe({
      next: res => {
        if (res?.data) {
          this.workflowStatusList = res.data;
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Workflow Status List");
        this._loaderService.setLoaderState(false);
      },
    });
  }

  showInputFieldForLineNote(workflowId: number) {
    this.workflowupdatesidebar.projectWorkflowId = workflowId;
    this.displaySidebarForNotes = true;
    this.workflowupdatesidebar.getWorkflowUpdatesList();
  }

  closeSideBarForOrderNotes() {
    this.displaySidebarForNotes = false;
    this.showListView(true);
  }

  descriptionCharacterCount(obj: string) {
    if (obj && obj.length > 45) this.descriptionCharacterCond = true;
  }

  redirectToDeliveryStatusAndException() {
    this.route.navigate(["/production-workflow/delivery-status-and-exception"]);
  }

  updateProjectWorkflowSorting(event: TableRowReorderEvent) {
    if (
      typeof event.dragIndex !== "number" ||
      typeof event.dropIndex !== "number"
    ) {
      return;
    }

    const orderedProjectList: ProductionWorkflowListDto[] =
      this.workflowList.map((element, index) => {
        element.sortOrder = index + 1;
        return element;
      });

    const request: UpdateProjectWorkflowSortingDto[] = orderedProjectList.map(
      (element: ProductionWorkflowListDto) => ({
        projectHeaderId: element.workflowId,
        sortOrder: element.sortOrder,
      })
    );

    this._loaderService.setLoaderState(true);
    this._workflowService.updateProjectWorkflowSorting(request).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res?.status?.toLowerCase() === "success") {
          this._toastr.success(
            "Success",
            res.message || "sorting applied successfully"
          );
        } else {
          this._toastr.error("Error", res.message || "Error on sorting");
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getPhaseStatus(status: number) {
    switch (status) {
      case EnumPhaseStatus.PreSale:
        return "Pre Sale";
      case EnumPhaseStatus.Production:
        return "Production";
      case EnumPhaseStatus.Delivered:
        return "Delivered";
      case EnumPhaseStatus.Cancelled:
        return "Cancelled";
      case EnumPhaseStatus.Completed:
        return "Completed";
      default:
        return "";
    }
  }

  getStatusClass(
    colorStatus: number,
    hasExceptions: boolean,
    status: number
  ): string {
    if (!hasExceptions && status === WorkflowStatusEnum.Complete) {
      return "success";
    } else {
      switch (colorStatus) {
        case EnumWorkflowHeaderColorStatus.Green:
          return "success";
        case EnumWorkflowHeaderColorStatus.Yellow:
          return "warning";
        case EnumWorkflowHeaderColorStatus.Red:
          return "danger";
        default:
          return "";
      }
    }
  }

  updateProjectWorkflowFlag(event: Event, workflow: ProductionWorkflowListDto) {
    event.stopPropagation();
    const payload: UpdateProjectWorkflowFlagDto = {
      workflowId: workflow.workflowId,
      isFlag: !workflow.isFlag,
    };

    this._loaderService.setLoaderState(true);
    this._workflowService.updateProjectWorkflowFlag(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res?.status?.toLowerCase() === "success") {
          workflow.isFlag = !workflow.isFlag;
          this._toastr.success(
            "Success",
            res.message || "flag updated successfully"
          );
        } else {
          this._toastr.error(
            "Error",
            res.message || "Error submitting workflow"
          );
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  updateProjectWorkflowIHD(event: Date, workflow: ProductionWorkflowListDto) {
    const date = new Date(event);
    workflow.inHandDate = this.datePipe.transform(date, "MM-dd-yyyy") ?? "";
    const payload: UpdateProjectWorkflowIhdDto = {
      projectWorkflowId: workflow.workflowId,
      saleOrderId: workflow.salesOrderIdD365,
      ihd: workflow.inHandDate!,
    };
    this._loaderService.setLoaderState(true);
    this._workflowService.updateProjectWorkflowIHD(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res?.status?.toLowerCase() === "success") {
          this._toastr.success(
            "Success",
            res.message || "IHD updated successfully"
          );
        } else {
          this._toastr.error(
            "Error",
            res.message || "Error submitting workflow"
          );
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  showCustomDialog() {
    this.showCustomFilterDialog = true;
  }

  closeCustomDialog() {
    this.showCustomFilterDialog = false;
    this.selectedColumnName = "";
    this.customValue = "";
    this.selectedRadioButton = "0";
    this.clearCustomFilter();
    this.onFilterInput(null);
  }

  clearCustomFilter() {
    this.isCustomFilter = false;
    this.customFilterDto = {
      columnName: "",
      value: "",
      tableName: "",
    };
  }

  applyCustomFilter() {
    if (this.isDateInput) {
      this.customValue =
        this.datePipe.transform(this.customDate, "yyyy-MM-dd") ?? "";
    }

    this.customFilterDto = {
      columnName: this.selectedColumnName,
      value: this.customValue,
      tableName:
        this.columnsList.find(cl => cl.name === this.selectedColumnName)
          ?.table ?? "",
    };
    this.isCustomFilter = true;
    this.selectedRadioButton = "0";
    this.onFilterInput(null);
  }

  onColumnNameChange() {
    this.resetInputFields();
    if (this.selectedColumnName === "isflag") {
      this.isRadioInput = true;
    } else if (
      this.selectedColumnName === "inhanddated365" ||
      this.selectedColumnName === "lastupdate"
    ) {
      this.isDateInput = true;
    } else if (this.selectedColumnName === "phasestatusid") {
      this.isPhaseList = true;
    } else if (this.selectedColumnName === "status") {
      this.isStatusList = true;
    } else {
      this.isTextInput = true;
    }
  }

  resetInputFields() {
    this.isTextInput = false;
    this.isDateInput = false;
    this.isPhaseList = false;
    this.isStatusList = false;
    this.isRadioInput = false;
    this.customValue = "";
  }

  searchCustomerName() {
    this.customerSearch$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.showSmallLoader = true;
          }
          const accountNumberOrName = searchitem;
          this.customerLists = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._customerAccountService.getCustomerByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.customerLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  onCustomerSearchOpenToggle(
    mydrop: Popover,
    event: KeyboardEvent,
    target: HTMLElement
  ) {
    mydrop.show(event, target);
  }

  onClientSelection(event: ClientSearchList, clientProspetToggle: Popover) {
    this.showSmallLoader = true;
    this.customerIdD365 = event.clientAccount;
    clientProspetToggle.hide();
    this.buyerName = "";
    this.buyerLists = [];
    this.getAllBuyers();
  }

  getCustomerAccount(event: Event, mydrop: Popover) {
    const keyEvent = event as KeyboardEvent;
    const target = event.target as HTMLInputElement;
    this.showSmallLoader = true;
    if (keyEvent.key.toLowerCase() === "tab") {
      const countryValue = target.value;
      this._customerAccountService
        .getCustomerByNameAndAccountNumberFilter(countryValue)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.customerLists = res.data;
            if (this.customerLists.length > 0) {
              this.onClientSelection(this.customerLists[0], mydrop);
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  getBuyer(event: Event, mydrop: Popover) {
    this.showSmallLoader = true;
    const keyEvent = event as KeyboardEvent;
    const target = event.target as HTMLInputElement;
    if (keyEvent.key.toLowerCase() === "tab") {
      const countryValue = target.value;
      const payload = {
        clientAccountNumber: this.customerIdD365 ?? "",
        buyer: countryValue,
      } as GetAllBuyersRequestDto;
      this._buyerService
        .getAllBuyers(payload)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.buyerLists = res.data;
            if (this.buyerLists.length > 0) {
              this.onBuyerSelection(this.buyerLists[0], mydrop);
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onBuyerSelection(
    event: GetAllBuyersResponseDto,
    buyerProspetToggle: Popover
  ) {
    this.buyerName = event.buyer;
    this.customerIdD365 = event.account;
    buyerProspetToggle.hide();
  }

  getTrackingLineItems(event: Event, workflow: ProductionWorkflowListDto) {
    event.stopPropagation();
    this.orderLines = [];
    this.linesPreview = true;
    if (workflow.workflowId && workflow.salesOrderIdD365) {
      this.workflowId = workflow.workflowId;
      this.salesOrderId = workflow.salesOrderIdD365;
      this.showSmallLoader = true;
      this._workflowService
        .getWorkflowLineItems(
          workflow.workflowId,
          workflow.salesOrderIdD365,
          false
        )
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res?.data && res?.status === "Success") {
              this.orderLines = res?.data.map(
                (element: ProductionWorkflowLineDto) => {
                  element.stackedDataOptions = {
                    labels: ["Status"],
                    datasets: [
                      {
                        label: "Delivered",
                        data: [element.deliveredCount],
                        backgroundColor: "#639853",
                      },
                      {
                        label: "In-Transit",
                        data: [element.inTransitCount],
                        backgroundColor: "#00a8f3",
                      },
                      {
                        label: "Shipped",
                        data: [element.shippedCount],
                        backgroundColor: "#ffcb00",
                      },
                      {
                        label: "Exception",
                        data: [element.exceptionCount],
                        backgroundColor: "#e93e3e",
                      },
                    ],
                  };
                  element.chartOptions = {
                    indexAxis: "y",
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                    responsive: true,
                    scales: {
                      x: {
                        stacked: true,
                        display: false,
                        max: element.trackingCount,
                      },
                      y: {
                        stacked: true,
                        display: false,
                      },
                    },
                    datasets: {
                      bar: {
                        stack: true,
                      },
                    },
                  };
                  return element;
                }
              );
            } else {
              this.orderLines = [];
            }
          },
          error: res => {
            this.showSmallLoader = false;
            this._toastr.error("Error", res.message);
          },
        });
    }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<ValidateLogin>) => {
          if (res?.data) {
            this.isAdmin = res.data.userRoleId === UserRole.Admin;
          } else {
            this.isAdmin = false;
          }
        },
      });
  }

  onContactList(
    contactdropdown: Popover,
    target: HTMLElement,
    event: MouseEvent
  ) {
    contactdropdown.show(event, target);
  }

  onBuyerSearchOpenToggle(
    mydrop: Popover,
    event: KeyboardEvent,
    target: HTMLElement
  ) {
    mydrop.show(event, target);
    const element = event.target as HTMLInputElement;
    if (element?.value != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
  }

  searchBuyerName() {
    this.buyerVendor$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.showSmallLoader = true;
          }

          const request = {
            clientAccountNumber: this.customerIdD365 || "",
            buyer: searchitem,
          } as GetAllBuyersRequestDto;

          this.buyerLists = [];
          if (searchitem) {
            return this._buyerService.getAllBuyers(request);
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.buyerLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  onClienySearchList(
    clientListDropDown: Popover,
    event: MouseEvent,
    target: HTMLElement
  ) {
    clientListDropDown.show(event, target);
  }

  onInputChanges(event: boolean) {
    this.projectHasUnSavedValues = event;
  }

  confirmProjectSummaryClose() {
    this.confirmationService.confirm({
      message: "You have unsaved changes. Do you really want to leave?",
      acceptLabel: "Yes",
      rejectLabel: "No",
      accept: () => {
        this.showWorkflowSummaryDialog = false;
        this.allTrue = true;
        this.projectHasUnSavedValues = false;
        this.showListView(true);
      },
      reject: () => {
        this.projectHasUnSavedValues = true;
      },
    });
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.projectHasUnSavedValues) {
      return new Observable<boolean>(observer => {
        this.confirmationService.confirm({
          message: "You have unsaved changes. Do you really want to leave?",
          acceptLabel: "Yes",
          rejectLabel: "No",
          accept: () => {
            this.projectHasUnSavedValues = false;
            observer.next(true);
            observer.complete();
          },
          reject: () => {
            observer.next(false);
            observer.complete();
          },
        });
      });
    } else {
      return true;
    }
  }

  getAllBuyers() {
    const request = {
      clientAccountNumber: this.customerIdD365 || "",
      buyer: "",
    } as GetAllBuyersRequestDto;
    this._buyerService
      .getAllBuyers(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.buyerLists = res.data;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  archiveEvent(workflowItems: ProductionWorkflowListDto, status: boolean) {
    if (status === true) {
      this.GetProjectActiveTasksCountByProjectId(workflowItems, status);
    } else {
      this.showArchieveDialog(workflowItems, status);
    }
  }

  showArchieveDialog(
    workflowItems: ProductionWorkflowListDto,
    status: boolean
  ) {
    const eventTxt = status ? "Archived" : "UnArchived";
    this.archiveMessage = replaceString(
      this.archiveMessage,
      this.getPaddedWorkflowId(workflowItems.workflowId),
      eventTxt
    );
    this.archivedProject = workflowItems.workflowId;
    this.archivedProjectStatus = status;
    this.archiveAlertVisible = true;
  }

  GetProjectActiveTasksCountByProjectId(
    workflowItems: ProductionWorkflowListDto,
    status: boolean
  ) {
    this._workflowService
      .GetProjectActiveTasksCountByProjectId(workflowItems.workflowId)
      .subscribe({
        next: async res => {
          this.showSmallLoader = false;
          if (
            res &&
            res.status.toLowerCase() === "success" &&
            res?.data === 0
          ) {
            this.showArchieveDialog(workflowItems, status);
          } else {
            this._toastr.error(
              "Error",
              `Open Task exists, can't archive the Project ${this.getPaddedWorkflowId(workflowItems.workflowId)} `
            );
          }
        },
      });
  }

  confirmArchive(event: boolean) {
    this.archiveAlertVisible = false;
    this.archiveMessage = "You want to mark the project <b>{0}</b> as {1}.";
    if (event && this.archivedProject) {
      const obj: MarkAsArchiveRequestDto = {
        workflowId: this.archivedProject,
        archivedStatus: this.archivedProjectStatus,
      };
      this.showSmallLoader = true;
      this._workflowService.MarkAsArchive(obj).subscribe({
        next: async res => {
          this.showSmallLoader = false;
          if (
            res &&
            res.status.toLowerCase() === "success" &&
            res?.data === true
          ) {
            this._toastr.success(
              "Success",
              "Project archive status has been changed"
            );
            this.getAllWorkflows(this.lazyLoadEvent);
          } else {
            this._toastr.error("Error", "Failed to Update Project");
          }
        },
        error: () => {
          this.showSmallLoader = false;
          this._toastr.error("Error", "Failed to Update Project");
        },
      });
    }
  }
}
